import styled from "@emotion/styled";

export const LoaderContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ExitWrapper = styled.div`
  position: absolute;
  top: 17.5px;
  left: 17.5px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
`;

export const SpinnerWrapper = styled.div``;

export const TextWrapper = styled.div``;
